import { Apollo_gql, GraphMutationPayload } from '@ta/server';

import { companyProps } from './dto/company';
import { companyMemberProps } from './dto/company-member';
import { ECompanyRole } from './dto/company-member';
import { estateManagerProps } from './dto/estate-manager';
import {
  CreateCompanyInput,
  InviteCompanyMemberInput,
  UpdateCompanyInput,
} from './form/dto/companyInput';

export function createCompany(company: Partial<CreateCompanyInput>): GraphMutationPayload {
  return {
    mutation: Apollo_gql`
      mutation CreateCompany($company: CreateCompanyInput!) {
        createCompany(input: $company) {
            ${companyProps.get('id')}
        }
      }
    `,
    variables: {
      company,
    },
  };
}

export function updateCompany(company: Partial<UpdateCompanyInput>): GraphMutationPayload {
  return {
    mutation: Apollo_gql`
      mutation UpdateCompany($company: UpdateCompanyInput!) {
        updateCompany(input: $company) {
            ${companyProps.get('id')}
        }
      }
    `,
    variables: {
      company,
    },
  };
}

export function inviteCompanyMember(member: InviteCompanyMemberInput): GraphMutationPayload {
  return {
    mutation: Apollo_gql`
      mutation InviteCompanyMember($member: InviteCompanyMemberInput!) {
        inviteCompanyMember(input: $member) {
            ${companyMemberProps.get('id')}
        }
      }
    `,
    variables: {
      member,
    },
  };
}

export function updateCompanyMemberRole(
  memberId: string,
  role: ECompanyRole,
): GraphMutationPayload {
  return {
    mutation: Apollo_gql`
      mutation UpdateCompanyMemberRole($member: UpdateCompanyMemberRoleInput!) {
        updateCompanyMemberRole(input: $member) {
            ${companyMemberProps.get('id')}
            ${companyMemberProps.get('role')}
        }
      }
    `,
    variables: {
      member: { memberId, role },
    },
  };
}

export function removeCompanyMember(memberId: string): GraphMutationPayload {
  return {
    mutation: Apollo_gql`
      mutation RemoveCompanyMember($memberId: UUID!) {
        removeCompanyMember(memberId: $memberId) {
            ${companyMemberProps.get('id')}
        }
      }
    `,
    variables: {
      memberId,
    },
  };
}

export function leaveCompany(): GraphMutationPayload {
  return {
    mutation: Apollo_gql`
      mutation LeaveCompany {
        leaveCompany {
            id
        }
      }
    `,
    variables: {},
  };
}

export function assignEstateManager(estateId: string, memberId: string): GraphMutationPayload {
  return {
    mutation: Apollo_gql`
      mutation AssignEstateManager($manager: EstateManagerInput!) {
        assignEstateManager(input: $manager) {
            ${estateManagerProps.get('id')}
        }
      }
    `,
    variables: {
      manager: { estateId, memberId },
    },
  };
}

export function unassignEstateManager(estateId: string, memberId: string): GraphMutationPayload {
  return {
    mutation: Apollo_gql`
      mutation UnassignEstateManager($manager: EstateManagerInput!) {
        unassignEstateManager(input: $manager)
      }
    `,
    variables: {
      manager: { estateId, memberId },
    },
  };
}
